import { render, staticRenderFns } from "./systemHead.vue?vue&type=template&id=24680056"
import script from "./systemHead.vue?vue&type=script&lang=js"
export * from "./systemHead.vue?vue&type=script&lang=js"
import style0 from "./systemHead.vue?vue&type=style&index=0&id=24680056&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports